module.exports = __webpack_public_path__ + "img/1.9c0bc329.jpg";